var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.valueModel,
          expression: "valueModel"
        }
      ],
      staticClass: "form-control",
      on: {
        change: function($event) {
          var $$selectedVal = Array.prototype.filter
            .call($event.target.options, function(o) {
              return o.selected
            })
            .map(function(o) {
              var val = "_value" in o ? o._value : o.value
              return val
            })
          _vm.valueModel = $event.target.multiple
            ? $$selectedVal
            : $$selectedVal[0]
        }
      }
    },
    [
      _vm._l(_vm.optionGroups, function(group) {
        return [
          group.path
            ? _c(
                "optgroup",
                { key: group.path, attrs: { label: group.path } },
                _vm._l(group.divisions, function(division) {
                  return _c(
                    "option",
                    {
                      key: division.id,
                      attrs: { disabled: !division.isEnabled },
                      domProps: {
                        value: division.id,
                        selected: _vm.valueModel === division.id
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(division.name) +
                          "\n            "
                      )
                    ]
                  )
                }),
                0
              )
            : _vm._l(group.divisions, function(division) {
                return _c(
                  "option",
                  {
                    key: division.id,
                    attrs: { disabled: !division.isEnabled },
                    domProps: {
                      value: division.id,
                      selected: _vm.valueModel === division.id
                    }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(division.name) + "\n        "
                    )
                  ]
                )
              })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }